import { ADD_WORKSPACE_FIELD_NAME } from '../AddWorkspaceModal.constants';
import { ADD_WORKSPACE_WS_NAME_NOT_FOUND_ERROR_CODE, ADD_WORKSPACE_WS_NO_SSO_CONFIGURED_ERROR_CODE, } from './add-workspace-error-codes';
export class WorkspaceNameNotFoundError extends Error {
    constructor(message) {
        super(message);
        this.name = 'WorkspaceNameNotFoundError';
    }
}
export class WorkspaceSsoNotConfiguredError extends Error {
    constructor(message) {
        super(message);
        this.name = 'WorkspaceSsoNotConfiguredError';
    }
}
/** Make sure the error code is added to `errors.json` files
 * when using this or changing the value of the field */
export const ADD_WORKSPACE_WS_NAME_NOT_FOUND_ERROR = {
    code: ADD_WORKSPACE_WS_NAME_NOT_FOUND_ERROR_CODE,
    path: [ADD_WORKSPACE_FIELD_NAME],
    message: '',
    isServerError: true,
};
/** Error when workspace exists but has no SSO configured
 * Make sure the error code is added to `errors.json` files
 * when using this or changing the value of the field */
export const ADD_WORKSPACE_WS_NO_SSO_CONFIGURED_ERROR = {
    code: ADD_WORKSPACE_WS_NO_SSO_CONFIGURED_ERROR_CODE,
    path: [ADD_WORKSPACE_FIELD_NAME],
    message: '',
    isServerError: true,
};
